<template>
  <div class="tval" @click="handleOpen" :title="textarea">
    {{textarea}}
    <!-- <el-input
      :disabled="disabled"
      type="textarea"
      resize="none"
      :rows="2"
      :placeholder="placeholder"
      v-model="input">
    </el-input> -->
    <TextPop v-if="isOpen" :isOpen.sync="isOpen" :rect="rectData" :column="column" :scope="scope" :textarea="textarea" @on-edit="handleEdit" />
</div>
</template>

<script>
import TextPop from './TextPop'
export default {
  props: ['column', 'scope'],
  components: {
    TextPop
  },
  data() {
    return {
      textarea: this.scope.row[this.column.prop],
      isOpen: false,
      rectData: {}
    }
  },
  watch: {
    scope({ row }) {
      this.textarea = row[this.column.prop]
    }
  },
  methods: {
    handleOpen(e) {
      const popels = document.getElementsByClassName('texteditpop')
      if (popels.length) {
        for (let i = 0; i< popels.length; i++) {
          popels[i].remove()
        }
      }
      const rect = e.target.parentElement.parentElement.getBoundingClientRect()
      this.isOpen = true
      this.rectData = rect
    },
    handleEdit(val) {
      this.textarea = val
      this.$emit('on-edit', val, this.column.prop, this.scope.$index)
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  height: 0;
}
.tval {
  height: 50px;
  padding-left: 10px;
  border-radius: 5px;
  border: 1px solid rgb(220, 223, 230);
  background-color: #FFF;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 50px;
}
</style>
